import { Injectable } from '@angular/core';
import { Store } from '@ngrx/store';
import { Storage } from '@c4/core';
import { Observable } from 'rxjs/Observable';
import { Subscriber } from 'rxjs/Subscriber';

export interface customDevice {
  host : string;
  address : string;
  isCustom : boolean;
}
export interface customDevices {
  customDevices?: customDevice[];
}

export const CUSTOM_DEVICE_GET = "SYSMAN_CUSTOM_DEVICE_GET";
export const CUSTOM_DEVICE_ADD = "SYSMAN_CUSTOM_DEVICE_ADD";
export const CUSTOM_DEVICE_REMOVE = "SYSMAN_CUSTOM_DEVICE_REMOVE";

export const customDeviceReducer = (state: customDevices, {type, payload}): customDevices => {
  switch (type) {

    case CUSTOM_DEVICE_GET:
      return Object.assign({}, state, { customDevices: payload });

    case CUSTOM_DEVICE_ADD:
      return Object.assign({}, state, { customDevices: payload });

    case CUSTOM_DEVICE_REMOVE:
      return Object.assign({}, state, { customDevices: payload });

    default:
      return state;
  }
}

@Injectable()
export class CustomDeviceService {

  constructor(private storage: Storage, protected store: Store<any>) {}

  public getCustomDevices() {

    console.log('CustomDeviceService.getCustomDevices()');
    var customDevices : Array<any> = this.storage.get('sysman-custom-devices');
    if (!customDevices)
        customDevices = [];

    this.store.dispatch({
        type: CUSTOM_DEVICE_GET,
        payload: { devices: customDevices }
    });
  }

  public addCustomDevice(addDeviceName : string, addDeviceAddress : string) {
    
    console.log('CustomDeviceService.addCustomDevice()', addDeviceName, addDeviceAddress);
    var customDevices : Array<any> = this.storage.get('sysman-custom-devices');
    if (!customDevices)
        customDevices = [];
    customDevices.push({"USN":addDeviceName,"address":addDeviceAddress,"isCustom":true});
    this.storage.set('sysman-custom-devices', customDevices);
    this.store.dispatch({
        type: CUSTOM_DEVICE_ADD,
        payload: { devices: customDevices }
    });
  }

  public removeCustomDevice(customDevice : any) {
    console.log('CustomDeviceService.removeCustomDevice()', customDevice);
    var customDevices : Array<any> = this.storage.get('sysman-custom-devices');
    if (!customDevices)
        customDevices = [];

    var foundIndex: number = -1;
    var i = 0;
    customDevices.forEach(item => {
        if (customDevice.address == item.address) {
            foundIndex = i;
            return true;
        }
        i++;
    });

    if (foundIndex > -1) {
        customDevices.splice(foundIndex,1);
        this.storage.set('sysman-custom-devices', customDevices);
    }

    this.store.dispatch({
      type: CUSTOM_DEVICE_REMOVE,
      payload: { devices: customDevices }
    });
  }

}



// WEBPACK FOOTER //
// ./~/@c4/sysman/src/app/services/custom-device.service.ts